import { ng } from '@uirouter/angularjs/lib/angular';
import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { taOptions } from 'textangular';
import * as _ from 'underscore';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { HtmlService } from '../../../../../app.common/modules/common/services/html.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { WysiwygService } from '../../../../../app.common/modules/common/services/wysiwyg.service';
import { PreviousStateService } from '../../../../../app.common/modules/routes/previous-state.service';
import { AccountService } from '../../../account/account.service';
import { BrandsService } from '../../../brands/brands.service';
import { CategoriesSelectorService } from '../../../categories/categoriesSelector.service';
import { IRetailerRootScope } from '../../../core/models';
import { FoodPreferenceService } from '../../../foodPreferences/foodPreference.service';
import { IProductVariationIngredient } from '../../../model/products/IProductVariationIngredient';
import { NfcRetailerStickersService } from '../../../nfc-stickers/nfc-retailer-stickers.service';
import { IBadge, IPhysicalProductVariation, ISpecialOfferChangeMessage } from '../../models';
import { IDiscountChangeMessage, IPreparationChangeMessage, ProductBaseController } from '../../productBase.controller';
import { ProductsService } from '../../products.service';
import { OffersService } from '../../services/offers.service';

interface IImageVariation {
    id: string;
    selected: boolean;
}

interface IPhysicalProductVariationWizard extends IPhysicalProductVariation {
    uniqueId: string;
}
class WizardProductController extends ProductBaseController {

    public static $inject = [
        '$rootScope', '$scope', '$q', '$stateParams', '$timeout', '$previousState', 'productsService',
        'categoriesSelectorService', 'brandsService', 'popupService', 'appWysiwygOptions', 'htmlService',
        'definitionsService', 'wysiwygService', 'notificationService', 'accountService', '$translate', 'nfcRetailerStickersService',
        'foodPreferenceService', '$localStorage', 'offersService', '$uibModal'
    ];

    public wizard = {
        step: 1,
        next: async () => {
            const wizard = this.wizard;
            if (wizard.step === 1 || wizard.step === 2) {
                wizard.step = await this.model.isValidProduct(false) ? wizard.step + 1 : wizard.step;
            } else if (await this.model.isValidModel(true)) {
                wizard.step++;
            }

            wizard.step = wizard.step > 4 ? 1 : wizard.step;

            if (wizard.step === 1) {
                $('html, body').animate({ scrollTop: 0 }, 500);
            }
        },
        back: () => {
            const i = this.wizard;
            if (i.step > 1) {
                i.step--;
            }
            this.variation = null;
        },
    };

    public nfrnWizard = {
        step: 1,
        next: async () => {
            const nfrnWizard = this.nfrnWizard;
            if (nfrnWizard.step === 1) {
                nfrnWizard.step = await this.model.isValidProduct(false) ? nfrnWizard.step + 1 : nfrnWizard.step;
            } else if (await this.model.isValidModel(true)) {
                nfrnWizard.step++;
            }

            nfrnWizard.step = nfrnWizard.step > 2 ? 1 : nfrnWizard.step;

            if (nfrnWizard.step === 1) {
                $('html, body').animate({ scrollTop: 0 }, 500);
            }
        },
        back: () => {
            const i = this.nfrnWizard;
            if (i.step > 1) {
                i.step--;
            }
            this.variation = null;
        },
    };

    public variationPreview = {
        imageID: null as string,
        images: [] as IImageVariation[],
        price: null as string | number,
        badges: [],
        oldPrice: null as string | number,
        size: '',
        color: '',
        set: (variation: IPhysicalProductVariation) => {
            const i = this.variationPreview;
            i.imageID = variation ? _.first(variation.imagesID) : null;
            i.price = variation ? variation.price : null;
            i.oldPrice = variation ? variation.oldPrice : null;
            i.size = variation ? variation.size : '';
            i.color = variation ? variation.color : '';
            i.color = variation ? variation.color : '';
            i.badges = variation ? this.filterBadges(variation.badges, true) : [];
            i.images = variation ? _.map(variation.imagesID, (imageID) => {
                return {
                    id: imageID,
                    selected: false
                };

            }) : [];
            const image = _.first(i.images);
            if (image) {
                image.selected = true;
            }
        },
        selectImage: (image: IImageVariation) => {
            const i = this.variationPreview;
            _.forEach(i.images, (img) => {
                img.selected = false;
            });
            image.selected = true;
            i.imageID = image.id;
        }
    };

    constructor(
        $rootScope: IRetailerRootScope,
        $scope: ng.IScope,
        $q: ng.IQService,
        $stateParams: StateParams,
        $timeout: ng.ITimeoutService,
        $previousState: PreviousStateService,
        productsService: ProductsService,
        categoriesSelectorService: CategoriesSelectorService,
        brandsService: BrandsService,
        popupService: PopupService,
        // tslint:disable-next-line:no-shadowed-variable
        taOptions: taOptions,
        htmlService: HtmlService,
        definitionsService: DefinitionsService,
        wysiwygService: WysiwygService,
        notificationService: NotificationService,
        accountService: AccountService,
        $translate: angular.translate.ITranslateService,
        nfcRetailerStickersService: NfcRetailerStickersService,
        foodPreferencesService: FoodPreferenceService,
        $localStorage: ngStorage.StorageService,
        offersService: OffersService,
        uibModal: ng.ui.bootstrap.IModalService
    ) {
        super($rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService,
            categoriesSelectorService, brandsService, popupService, taOptions, htmlService, definitionsService,
            wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal);

        this.variation = null as IPhysicalProductVariationWizard;
        this.model.loadedModel = this.loadedModel;
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public editVariation = (variation: IPhysicalProductVariationWizard) => {
        variation.error = null;
        this.variation = angular.copy(variation);
    }

    public addVariation = () => {
        const defaultVariation = this.productsService.getDefaultVariationModel();
        const ingredientList = this.model.edit.ingredientList;
        if (ingredientList.length > 0) {
            ingredientList.forEach((item) => {
                const ingredient: IProductVariationIngredient = {
                    ID: item.ID,
                    Title: item.Title,
                    Price: null,
                    InsidePrice: null,
                    DefaultQuantity: item.MinQuantity,
                    MaxQuantity: 1
                };
                defaultVariation.ingredients.push(ingredient);
            });
        }
        this.variation = defaultVariation;
        (this.variation as IPhysicalProductVariationWizard).uniqueId = this.getUniqueId();
    }

    public cancelVariation() {
        if (this.variation) {
            _.forEach(this.variation.imagesID, (id) => {
                this.deleteImage(id);
            });
        }
        this.variation = null;
    }

    public saveVariation = (variation: IPhysicalProductVariation) => {

        if (this.model.isValidVariation(variation)) {
            if (this.productForm) {
                this.productForm.$setDirty();
            }
            this.updateVariation(variation as IPhysicalProductVariationWizard);
            this.model.isValidArrayVariations();
            this.variation = null;
        }
    }

    public changeVariationDiscount(discountMessage: IDiscountChangeMessage) {
        this.variation.discount = discountMessage.discount;
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    }

    public changeVariationPreparationTime(preparationMessage: IPreparationChangeMessage) {
        this.variation.isHot = preparationMessage.isHot;
        this.variation.preparationTime = preparationMessage.preparationTime;
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    }

    public onChangeSpecialOffer(message?: ISpecialOfferChangeMessage) {
        super.onChangeSpecialOffer(message);
    }

    public copyVariation = async (variation: IPhysicalProductVariationWizard) => {
        if (!this.model.isValidVariation(variation)) {
            return;
        }
        const copy = angular.copy(variation);
        copy.id = null;
        copy.imagesID = [];
        copy.uniqueId = this.getUniqueId();

        this.updateSelectedSizes(copy);
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            const dictionary = await this.productsService.copyImage(variation.imagesID);

            this.notificationService.showSuccessMessage({
                title: this.$translate.instant('success'),
                body: this.$translate.instant('variation_was_copied')
            });
            copy.id = null;
            copy.uniqueId = this.getUniqueId();

            _.forEach(variation.imagesID, (id) => {
                const newID = dictionary[id];
                if (newID) {
                    copy.imagesID.push(newID);
                }
            });
            this.updateVariation(variation);
            this.variation = copy;
            this.model.isValidArrayVariations();
            this.productForm.$setDirty();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public async showIngredientAttentionIfNeed() {
        const needShowAttentions: boolean = this.variation.ingredients.length > 0;

        if (needShowAttentions) {
            super.showIngredientAttentionDialog();
        }
    }

    public onIngredientChanged(item: IProductVariationIngredient, variation: IPhysicalProductVariation) {
        this.productForm.$setDirty();
    }

    public saveWizard = () => {
        const saveVariation = this.isNfrnRetailer ? this.nfrnWizard.step === 1 : this.wizard.step === 2;
        if (saveVariation && this.variation) {
            this.saveVariation(this.variation);
            if (this.variation) {
                return;
            }
        }
        this.save();
    }

    public removeVariationWizard = (variation: IPhysicalProductVariation) => {
        if (_.size(this.model.edit.variations) === 1) {
            return;
        }
        this.removeVariation(variation, () => {
            this.model.isValidArrayVariations();
            this.variation = null;
        });
    }

    public discardWizard = () => {
        const variationsImages = this.model.getClientImagesID();
        let currentVariationImages: string[] = [];

        if (this.variation && _.size(this.variation.imagesID) > 0) {
            currentVariationImages = this.variation.imagesID;
        }

        _.forEach(_.union(variationsImages, currentVariationImages), (id) => {
            this.deleteImage(id);
        });

        this.productForm.$setDirty();
        this.back();
    }

    public filterBadges = (badges: IBadge[], selected: boolean) => {
        if (_.isUndefined(selected)) {
            return _.reject(badges, (badge) => {
                return badge.key === 0;
            });
        }
        return _.reject(badges, (badge) => {
            return badge.key === 0 || badge.selected !== selected;
        });
    }

    public async openIngredientsInfo() {
        try {
            await this.popupService.info({
                title: this.$translate.instant('ingredient_info_dialog_title'),
                content: this.$translate.instant('ingredient_info_dialog_content')
            });
        } catch (e) { return; }
    }

    public async openVariationIngredientsInfo() {
        try {
            await this.popupService.info({
                title: this.$translate.instant('variation_ingredient_list_title'),
                content: this.$translate.instant('variation_ingredient_info_dialog_content')
            });
        } catch (e) { return; }
    }

    public getTextSizeColor() {
        const caseFunction = String.prototype.toUpperCase;
        if (this.IsFoodProduct) {
            return this.getSizeNameAndColorText('SIZE, CHOOSE', caseFunction);
        } else {
            return this.getSizeNameAndColorText('SIZE, COLOR', caseFunction);
        }
    }

    public getTextSizeColorForDescription() {
        const caseFunction = String.prototype.toLowerCase;
        if (this.IsFoodProduct) {
            return this.getSizeNameAndColorText('size/choose', caseFunction);
        } else {
            return this.getSizeNameAndColorText('size/color', caseFunction);
        }
    }

    public getSizeNameAndColorText(title: string, caseFunction: (_: string) => string) {
        const editModel = this.model.edit;
        if (!editModel || !editModel.sizeName) { return title; }

        title = caseFunction.apply(editModel.sizeName);
        if (editModel.colourName) {
            title += `/${ caseFunction.apply(editModel.colourName)}`;
        }

        return title;
    }

    protected updateVariationPreview = () => {
        if (this.model.edit == null) {
            return;
        }
        if (this.variation) {
            this.variationPreview.set(this.variation);
        } else {
            let applicant = _.find(this.model.edit.variations, (variation) => {
                return _.size(variation.imagesID) > 0;
            });

            if (_.isUndefined(applicant)) {
                applicant = _.first(this.model.edit.variations);
            }

            this.variationPreview.set(applicant);
            this.phoneScroll();
            this.textAreaCustScroll();
            this.srollTableTag();
        }
    }

    private getUniqueId() {
        return _.uniqueId('temp');
    }

    private updateVariation = (variation: IPhysicalProductVariationWizard) => {
        let index = -1;
        if (variation.id) {
            index = _.findIndex(this.model.edit.variations, { id: variation.id });
        } else if (variation.uniqueId) {
            index = _.findIndex(this.model.edit.variations, { uniqueId: variation.uniqueId });
        }
        if (index === -1) {
            this.model.edit.variations.unshift(variation);
        } else {
            this.model.edit.variations[index] = variation;
        }
    }

    private phoneScroll() {
        $('.wizardScrollPhone').slimScroll({
            height: 'auto'
        });
    }
    private textAreaCustScroll() {
        $('.textAreaCustScroll').slimScroll({
            height: '150px'
        });
    }

    private srollTableTag() {
        $('.srollTableTag').slimScroll({
            height: '446px',
            alwaysVisible: true
        });
    }

    private loadedModel = () => {
        _.forEach(this.model.edit.variations, (variation: IPhysicalProductVariationWizard) => {
            if (!variation.id) {
                variation.uniqueId = this.getUniqueId();
            }
        });
        this.updateVariationPreview();
    }

}
angular
    .module('naut').component('wizardProduct', {
        template: require('./wizardProduct.html'),
        controller: WizardProductController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/wizardProduct/wizardProduct.component.ts